import { ConfirmUpdateOrderSchema } from "@redotech/redo-agents-cards/support-agents/confirm-update-order";
import { ContentType } from "@redotech/redo-support-common/conversation";
import * as z from "zod";
import {
  array,
  boolean,
  literal,
  number,
  object,
  string,
  enum as zodEnum,
} from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

export const UpdateOrderCustomerInputContentSchema = object({
  confirmed: boolean().optional(),
  items: array(
    object({
      variantId: string().optional(),
      quantity: number().optional(),
      action: zodEnum(["add", "remove"]).optional(),
    }),
  ).optional(),
});

export const UpdateOrderMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.UPDATE_ORDER),
  structuredContent: ConfirmUpdateOrderSchema,
  customerInputContent: UpdateOrderCustomerInputContentSchema.optional(),
});

export const UpdateOrderMessageDbParser = UpdateOrderMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type UpdateOrderMessageType = z.infer<typeof UpdateOrderMessageDbParser>;
export type UpdateOrderMessageTypeWithoutId = WithoutId<UpdateOrderMessageType>;
